export default "__VITE_ASSET__Czrva1OB__"